import React from "react";

import Form from "react-bootstrap/Form";

import { UploadImage } from "../../UploadImage";
import { RequiredText } from "../../RequiredText";
import { TrashButton } from "../../TrashButton";

export default function BasicInfo({
  requiredFieldErrorStatus,
  seasons,
  flexPack,
  image,
  setImage,
  handleSeason,
  setCoordinates,
  coordinates,
  handleRemove,
  isDisabled,
  isFlexPackPublished,
}) {
  return (
    <>
      <Form.Group className="form-group" controlId="season">
        <div className="form-label--flex">
          <Form.Label>Season</Form.Label>
          {requiredFieldErrorStatus?.season && <RequiredText />}
        </div>
        <Form.Select
          name="season"
          disabled={isDisabled || isFlexPackPublished}
          value={flexPack?.season?.id || ""}
          onChange={handleSeason}
          className={requiredFieldErrorStatus?.season ? "error-border" : ""}
          autoFocus
        >
          <option disabled hidden value="">
            Season
          </option>
          {seasons &&
            seasons.map((season, index) => (
              <option value={season.id} key={index}>
                {season?.organization?.name} - {season?.name}
              </option>
            ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="form-group" controlId="thumbnail">
        <div className="form-label--flex">
          <Form.Label>Thumbnail</Form.Label>
          {requiredFieldErrorStatus?.image && <RequiredText />}
        </div>
        <div
          className={`${image ? "flex" : ""} ${requiredFieldErrorStatus?.image ? "error-border error-border--with-radius" : ""}`}
        >
          <UploadImage
            dropzoneSize="sm"
            dropzoneWithRadius={true}
            selectedImage={image}
            setSelectedImage={setImage}
            setCoordinates={setCoordinates}
            coordinates={coordinates}
            size="lg"
            altText={`Cover art for ${flexPack?.name} flex package`}
          />
          {image && (
            <TrashButton
              onClick={handleRemove}
              isDisabled={isDisabled}
              variant="danger"
            />
          )}
        </div>
      </Form.Group>
    </>
  );
}
